import { render, staticRenderFns } from "./Kamusfavorite.vue?vue&type=template&id=21d92200&scoped=true&"
import script from "./Kamusfavorite.vue?vue&type=script&lang=js&"
export * from "./Kamusfavorite.vue?vue&type=script&lang=js&"
import style0 from "./Kamusfavorite.vue?vue&type=style&index=0&id=21d92200&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d92200",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
